import text from "./text";

function parser(type) {
  return function(input, init)  {
    return text(input, init).then(function(text) {
      return (new DOMParser).parseFromString(text, type);
    });
  };
}

export default parser("application/xml");

export var html = parser("text/html");

export var svg = parser("image/svg+xml");



//////////////////
// WEBPACK FOOTER
// ./~/d3-fetch/src/xml.js
// module id = 4Me5
// module chunks = 0